import * as React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, FormControl, FormControlLabel, Radio, RadioGroup, IconButton
} from "@material-ui/core";
import HorizontalAutoCalculationComponent from './HorizontalAutoCalculationComponent';
import VerticalAutoCalculationComponent from './VerticalAutoCalculationComponent';
import VerticalAutoCalculationForAdminLevelComponent from './VerticalAutoCalculationForAdminLevelComponent';
import { QuestionType } from 'src/constants/Enum/ModuleEnum';
import CloseIcon from '@material-ui/icons/Close';

const configuration = {
    is_horizontal: false,
    horizontal_config: null,
    vertical_config: null
};

export default class AutoCalculationComonent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false,
            fullWidth: true,
            maxWidth: 'sm',
            selectionValue: 'Horizontal',
            isHorizontal: true,
            horizontalConfig: {
                operand_one_set: '',
                operand_two_set: '',
                operator: ''
            },

        }
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSetOneChange = this.handleSetOneChange.bind(this);
        this.handleSetTwoChange = this.handleSetTwoChange.bind(this);
        this.handleOperator = this.handleOperator.bind(this);
        this.handleApplyChanges = this.handleApplyChanges.bind(this);
        this.onVerticalQuestionChange = this.onVerticalQuestionChange.bind(this);
        this.onVerticalOperatorChange = this.onVerticalOperatorChange.bind(this);
        this.onVerticalAddMore = this.onVerticalAddMore.bind(this);
    }


    componentDidMount() {

        this.setState({
            horizontalConfig: {
                operand_one_set: this.props.question.auto_calculation_config && this.props.question.auto_calculation_config.horizontal_config && this.props.question.auto_calculation_config.horizontal_config.operand_one_set ? this.props.question.auto_calculation_config.horizontal_config.operand_one_set : 1,
                operand_two_set: this.props.question.auto_calculation_config && this.props.question.auto_calculation_config.horizontal_config && this.props.question.auto_calculation_config.horizontal_config.operand_two_set ? this.props.question.auto_calculation_config.horizontal_config.operand_two_set : 2,
                operator: this.props.question.auto_calculation_config && this.props.question.auto_calculation_config.horizontal_config && this.props.question.auto_calculation_config.horizontal_config ? this.props.question.auto_calculation_config.horizontal_config.operator : '+'
            }
        });
        if (this.props.question.auto_calculation_config) {
            console.log("this.props.question.auto_calculation_config",this.props.question.auto_calculation_config);
            if (this.props.question.auto_calculation_config.horizontal_config === null && this.props.question.auto_calculation_config.vertical_config === null
                && this.props.question.class_type > 2) {
                this.setState({ selectionValue: 'Horizontal', isHorizontal: true });
            }
            else if (this.props.question.auto_calculation_config.horizontal_config !== null && this.props.question.class_type > 2) {
                this.setState({ selectionValue: 'Horizontal', isHorizontal: true });
            }
            else {
                this.setState({ selectionValue: 'Vertical', isHorizontal: false });
            }
        }
    }

    handleSetOneChange = (value: any) => {
        const errorName = 'error';
        this.setState({
            horizontalConfig: { ...this.state.horizontalConfig, operand_one_set: value },
            [errorName]: undefined
        });
    }

    handleSetTwoChange = (value: any) => {
        const errorName = 'error';
        this.setState({
            horizontalConfig: { ...this.state.horizontalConfig, operand_two_set: value },
            [errorName]: undefined
        });
    }

    handleOperator(value: any) {
        this.setState({
            horizontalConfig: { ...this.state.horizontalConfig, operator: value }
        });
    }

    handleClose = () => {
        this.props.onClose(true);
    }

    handleChange = (e: any) => {
        this.setState({ selectionValue: e.target.value, isHorizontal: e.target.value === 'Horizontal' });
    }

    handleApplyChanges = () => {
        if (this.state.isHorizontal) {
            const errorName = 'error';
            if (this.state.horizontalConfig.operand_one_set === this.state.horizontalConfig.operand_two_set) {
                this.setState({ [errorName]: 'Please make sure options selected are different for Set 1 and Set 2.' });
                return;
            }
            this.saveHorizontalConfiguration();
        }
        else {
            this.saveVerticalAutoCalculation();
        }
    }

    saveVerticalAutoCalculation = () => {
        const verticalConfig: any = this.parseStateToObjectForVerticalCalculation();
        if (!this.validateVerticalConfiguration(verticalConfig)) {

            configuration.is_horizontal = this.state.isHorizontal;
            configuration.vertical_config = verticalConfig;
            configuration.horizontal_config = null;

            this.props.updateModule({
                data: {
                    pageNumber: this.props.pageNumber,
                    clusterIndex: this.props.clusterIndex,
                    questionIndex: this.props.questionIndex,
                    value: configuration,
                    isHorizontal: this.state.isHorizontal
                },
                field: 'verticalConfig'
            });
            this.handleClose();
        }

    }
    saveHorizontalConfiguration = () => {

        configuration.is_horizontal = this.state.isHorizontal;
        configuration.horizontal_config = this.state.horizontalConfig
        configuration.vertical_config = null;

        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
                questionIndex: this.props.questionIndex,
                value: configuration
            },
            field: 'horizontalConfig'
        });
        this.handleClose();
    }

    onVerticalQuestionChange = (stateName: any, data: any) => {
        this.setState({ [stateName]: data });
    }

    onVerticalOperatorChange = (data: any) => {
        this.setState({ verticalOperator: data, ['error']: undefined });
    }

    onVerticalAddMore = (stateName: any, data: any) => {
        this.setState({ [stateName]: data, ['error']: undefined });
    }

    parseStateToObjectForVerticalCalculation = () => {
        let verticalAutoCalculationObj: any = {};
        const setWiseQuestions = []
        for (let setIndex = 1; setIndex <= this.props.question.class_type; setIndex++) {
            const questionIds = [];
            const name = `questionId_${setIndex}`;
            for (let index = 1; index <= this.state.questionId[name].counters.length; index++) {
                const questionId = this.state[`questionId_${setIndex}${index}`];
                if (questionId) {
                    questionIds.push(questionId);
                }
            }
            setWiseQuestions.push({
                set_no: setIndex,
                question_ids: questionIds
            });
        }

        verticalAutoCalculationObj = {
            operator: this.state.verticalOperator,
            set_wise_questions: setWiseQuestions
        }

        return verticalAutoCalculationObj;
    }

    validateVerticalConfiguration = (config: any) => {
        const errors = [];
        for (let index = 0; index < config.set_wise_questions.length; index++) {
            if(config.set_wise_questions[index].question_ids.length === 0){
                errors.push(`Please select question for set ${index + 1}.`);
                    break; 
            }
            for (const questionId of config.set_wise_questions[index].question_ids) {
                const questionIds = config.set_wise_questions[index].question_ids.filter((conf: any) => conf === questionId);
                if (questionIds.length > 1) {
                    errors.push(`Please select different question for set ${index + 1}. Question selected once should not be selected again.`);
                    break;
                }
            }
        }
        this.setState({ ['error']: errors && errors.length > 0 ? errors[0] : undefined });

        return errors.length > 0
    }

    render() {
        const error = 'error';
        return (
            <>
                <Dialog
                    fullWidth={this.state.fullWidth}
                    hideBackdrop={true}
                    maxWidth={this.state.maxWidth}
                    open={this.props.showDialog}
                    aria-labelledby="max-width-dialog-title"
                    className="applicationDialog"
                >

                    <div className="dialogWrapper">
                        <div className="dialogHead">
                            <DialogTitle id="max-width-dialog-title text-right" className="dialogTitle">Auto Calculation
                                <IconButton aria-label="Close" className="closeButton" onClick={this.handleClose}>
                                    <CloseIcon />
                                </IconButton>
                                <hr className="HZDivider" />
                            </DialogTitle>
                        </div>

                        <div className="dialogContent">
                            <DialogContent>
                                <Grid container={true} spacing={40} direction="row" justify="center" alignItems="center">
                                    <Grid item={true} xs={6}>
                                        <FormControl className="formControl">
                                            <RadioGroup
                                                aria-label="position"
                                                name="position"
                                                value={this.state.selectionValue}
                                                onChange={this.handleChange}
                                                row={true}
                                            >
                                                {
                                                    this.props.question.class_type > 2 && (
                                                        <FormControlLabel
                                                            value="Horizontal"
                                                            control={<Radio color="primary" />}
                                                            label="Horizontal"
                                                            labelPlacement="end"
                                                        />
                                                    )
                                                    }
                                                    <FormControlLabel
                                                    value="Vertical"
                                                    control={<Radio color="primary" />}
                                                    label="Vertical"
                                                    labelPlacement="end"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>

                                <div hidden={!this.state[error]} className="errorMessage">{this.state[error]}</div>

                                <Grid container={true} spacing={24}>
                                    {/* Horizontal */}
                                    {
                                        this.props.question.class_type > 2 && this.state.isHorizontal ? (
                                            <Grid item={true} xs={12}>
                                                <HorizontalAutoCalculationComponent
                                                    configuration={this.state.horizontalConfig}
                                                    onSetOneChange={this.handleSetOneChange}
                                                    onSetTwoChange={this.handleSetTwoChange}
                                                    onOperatorChange={this.handleOperator}
                                                />
                                            </Grid>
                                        )
                                        :
                                        this.props.question.class_type > 2 && this.state.isHorizontal && this.props.question.input_type === QuestionType.AdminLevel ? (
                                            <Grid item={true} xs={12}>
                                                <HorizontalAutoCalculationComponent
                                                    configuration={this.state.horizontalConfig}
                                                    onSetOneChange={this.handleSetOneChange}
                                                    onSetTwoChange={this.handleSetTwoChange}
                                                    onOperatorChange={this.handleOperator}
                                                />
                                            </Grid>
                                        )
                                        :
                                        ''
                                    }                                  
                                     {/* Vertical -Admin level questions*/}
                                     
                                     {this.state.isHorizontal === false && this.props.question.input_type === QuestionType.AdminLevel ?(
                                        <Grid item={true} xs={12}>
                                            <VerticalAutoCalculationForAdminLevelComponent
                                                allData={this.props.allData}
                                                question={this.props.question}
                                                pageNumber={this.props.pageNumber}
                                                clusterIndex={this.props.clusterIndex}
                                                questionIndex={this.props.questionIndex}
                                                onVerticalQuestionChange={this.onVerticalQuestionChange}
                                                onVerticalOperatorChange={this.onVerticalOperatorChange}
                                                onVerticalAddMore={this.onVerticalAddMore}
                                                verticalConfig={this.state.verticalConfig}
                                            />
                                        </Grid>
                                    ) : this.state.isHorizontal === false ?  (
                                        <Grid item={true} xs={12}>
                                            <VerticalAutoCalculationComponent
                                                allData={this.props.allData}
                                                question={this.props.question}
                                                pageNumber={this.props.pageNumber}
                                                clusterIndex={this.props.clusterIndex}
                                                questionIndex={this.props.questionIndex}
                                                onVerticalQuestionChange={this.onVerticalQuestionChange}
                                                onVerticalOperatorChange={this.onVerticalOperatorChange}
                                                onVerticalAddMore={this.onVerticalAddMore}
                                                verticalConfig={this.state.verticalConfig}
                                            />
                                        </Grid>
                                    ):''
                                    }
                                </Grid>

                            </DialogContent>
                        </div>

                        <div className="dialogAction">
                            <hr className="HZDivider" />
                            <DialogActions>
                                <Button color="primary" className="btn-blue-primary" onClick={this.handleApplyChanges}>
                                    Apply Rule &nbsp; >
                                </Button>
                            </DialogActions>
                        </div>

                    </div>
                </Dialog>
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/questions/AutoCalculationComponent.tsx